[data-react-fleet-view-panel="true"] {
  background: var(--results-shell-main);
}

[data-fleet-sequence-scroll-region="true"] thead tr,
[data-fleet-sequence-scroll-region="true"] thead th {
  background: #eee9e3;
}

[data-fleet-suspended-panel="true"] {
  background: #b3aba4;
  border-color: #a69c92;
}

[data-fleet-suspended-panel="true"] > div:first-child h4 {
  color: #fff;
  font-size: 12px;
}

[data-fleet-suspended-panel="true"] :is([data-suspended-delivery-card], [data-suspended-delivery-group-card]) span.rounded-full {
  border-radius: 4px;
  font-size: 11px;
  line-height: 14px;
  padding: 3px 7px;
}

[data-fleet-suspended-panel="true"] > div:first-child {
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;
}

[data-fleet-suspended-panel="true"] > div:first-child > div:first-child {
  flex: 1 1 auto;
  white-space: nowrap;
}

[data-fleet-suspended-panel="true"] > div:first-child > div:last-child {
  gap: 4px;
}

[data-fleet-suspended-panel="true"] > div:first-child > div:last-child > :is(label, button) {
  justify-content: center;
  height: 20px;
  min-height: 20px;
  padding: 0 4px;
  border: 1px solid #6e6258;
  border-radius: 4px;
  background: #fff;
  color: #39312a;
  font-size: 11px;
  font-weight: 600;
}

[data-fleet-suspended-panel="true"] > div:first-child > div:last-child > span {
  height: 20px;
  min-height: 20px;
  padding: 0 5px;
  line-height: 18px;
  border-radius: 4px;
}

[data-fleet-suspended-panel="true"] > div:first-child > div:last-child > button {
  margin-left: auto;
}

.fleet-view-toolbar-section,
[data-fleet-suspended-panel="true"] > div:first-child,
[data-react-fleet-view-panel] div:has(> [data-fleet-selection-heading="Séquence route"]) {
  background: #39312a;
  border: 1px solid #494039;
  border-radius: 4px;
  padding: 4px 6px;
}

.fleet-view-toolbar-section[aria-label="Commandes de la carte routière"] {
  justify-content: center;
}

body.results-page [data-app-shell='true'] [data-react-fleet-view-panel] .route-stage__map-shell {
  border-color: #39312a;
  border-radius: 4px;
}

[data-fleet-view-toolbar="true"] h2,
[data-fleet-selection-heading="Séquence route"] h3 {
  color: #fff;
}

/* Match the timeline/map grid below, without an extra frame or divider. */
[data-fleet-view-toolbar="true"] {
  gap: 0.375rem;
  padding: 0;
  border: 0;
  background: transparent;
  min-width: 0;
}

[data-fleet-view-toolbar="true"] :is(
  [data-fleet-view-display-controls] > button,
  button[aria-haspopup="dialog"],
  [aria-label="Commandes de la carte routière"] > button,
  label:has(> [data-route-map-group-range-toggle]),
  div:has(> input[type="search"])
) {
  height: 30px;
  min-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 4px;
  font-size: 0.68rem;
}

[data-fleet-view-toolbar="true"] input[type="search"] {
  font-size: 0.68rem;
}


[data-fleet-selection-heading="Séquence route"] p {
  color: #eee9e3;
}

.fleet-selection-heading {
  display: grid;
  gap: 2px;
  min-width: 0;
  border-left: 3px solid var(--color-accent);
  padding-left: 7px;
  overflow-wrap: anywhere;
}

/* Rails follow the timeline height; the suspended list scrolls in the rest. */
@media (min-width: 1280px) {
  .fleet-timeline-inspector-layout > [data-fleet-inspector-rail] {
    contain: size;
    align-self: stretch;
    display: flex;
    flex-direction: column;
  }

  .fleet-timeline-inspector-layout > [data-fleet-inspector-rail] > * {
    flex-shrink: 0;
  }

  .fleet-timeline-inspector-layout [data-fleet-suspended-panel] {
    flex: 1;
    min-height: 8rem;
    grid-template-rows: auto minmax(0, 1fr);
  }

  .fleet-timeline-inspector-layout > [data-fleet-inspector-rail] [data-fleet-suspended-panel] > :last-child {
    max-height: none !important;
  }
}

/* Scoped to the consulted fleet cards, including their portal renderings. */
.fleet-context-surface {
  --color-content-muted: var(--color-content-copy);
  position: relative;
  border-radius: 4px !important;
  box-shadow: none;
}
.fleet-context-surface::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 2px;
  border-radius: 4px 4px 0 0;
  background: var(--fleet-context-accent, var(--hovercard-accent-neutral));
  pointer-events: none;
}
.fleet-context-surface [data-fleet-context-identity] {
  min-width: 0;
  overflow-wrap: anywhere;
  color: var(--color-content-copy);
  font-size: .68rem;
  font-weight: 600;
}
.fleet-context-actions {
  flex-wrap: wrap;
}
.fleet-context-actions button,
.fleet-context-surface > div:first-of-type :is(span[class*="rounded"], button),
.fleet-context-surface > [data-fleet-context-feedback] {
  border-radius: 4px !important;
}
.fleet-context-actions button:disabled {
  box-shadow: none;
}
.fleet-context-popover-surface {
  box-shadow: 0 8px 24px rgb(15 23 42 / .12);
}

/* PM keeps its compact actions and editor inside the floating card. */
.fleet-context-pm > div {
  min-width: 0;
}
.fleet-context-pm [data-fleet-pm-footer],
.fleet-context-pm [data-fleet-pm-footer] > div > div {
  border-radius: 4px;
}
.fleet-context-pm [data-fleet-pm-footer] {
  background-color: white;
}
.fleet-pm-editor > div {
  min-width: 0;
}

/* Paint only: the timeline owns segment placement, width and service duration. */
.fleet-timeline-segment {
  border-color: rgb(0 0 0 / .55);
}
.fleet-timeline-segment:hover {
  border-color: rgb(0 0 0 / .75);
}
.fleet-timeline-segment .fleet-timeline-sequence-badge {
  height: calc(1.875rem - 2px);
  border-radius: 0;
  border-right-color: color-mix(in srgb, currentColor 18%, transparent);
  background-color: rgb(15 23 42 / .04);
}

/* Compact controls leave the embedded route visible beneath the overlay. */
.fleet-map-overlay-controls {
  pointer-events: none;
  top: 2px;
  left: 2px;
  right: 2px;
}
.fleet-map-overlay-controls :is(button, label) {
  background: #39312a;
  border-color: #494039;
  color: #fff;
  pointer-events: auto;
  height: 18px;
  min-height: 18px;
  padding: 0 3px;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: normal;
  border-radius: 4px;
}

.fleet-map-overlay-controls :is(button, label):hover {
  background: #494039;
  border-color: #6e6258;
  color: #fff;
}

[data-fleet-inspector-rail]:has(.fleet-map-overlay-controls) {
  padding: 2px;
  border-radius: 4px;
}

/* Vue flotte : cartes blanches sur fond pâle, espacements serrés pour laisser
   le maximum de place au répartiteur.
   Le rayon de 8 px est réservé aux conteneurs de premier niveau (Gantt, carte,
   commandes suspendues, séquence route) ; leur contenu conserve 4 px. */
[data-react-fleet-view-panel="true"] {
  --fleet-card-ground: #efede8;
  --fleet-card-surface: #fff;
  --fleet-card-border: #e3e0d9;
  --fleet-card-radius: 8px;
  --fleet-card-gap: 6px;
  --fleet-card-padding: 4px;
  --fleet-card-shadow: 0 1px 2px rgb(28 25 20 / .06), 0 2px 8px rgb(28 25 20 / .05);
  background: var(--fleet-card-ground);
}

/* Le cadre blanc du tableau de résultats s'efface : le fond pâle va jusqu'au bord. */
#results-board:has(> [data-results-analysis-stage-root][data-active-view="fleet"]) {
  padding-inline: 0;
  padding-bottom: 0;
  border-color: transparent;
  background: #efede8;
}

[data-react-fleet-view-panel="true"] > div:first-child {
  gap: var(--fleet-card-gap);
  padding: var(--fleet-card-gap);
  border-bottom: 0;
}

[data-react-fleet-view-panel="true"] div:has(> [data-fleet-inspector-rail="true"]) {
  gap: var(--fleet-card-gap);
}

body.results-page [data-app-shell="true"] [data-react-fleet-view-panel="true"] [data-fleet-inspector-rail="true"] {
  gap: var(--fleet-card-gap);
  padding: 0;
  overflow: visible;
  border: 0;
  background: transparent;
  box-shadow: none;
}

[data-react-fleet-view-panel="true"] div:has(> div > [data-fleet-view-toolbar="true"]):has(> [data-fleet-timeline-panel="true"]),
[data-react-fleet-view-panel="true"] [data-fleet-inspector-rail="true"] > [data-react-route-map-panel="true"],
body.results-page [data-app-shell="true"] [data-react-fleet-view-panel="true"] [data-fleet-inspector-rail="true"] > [data-fleet-suspended-panel="true"],
[data-react-fleet-view-panel="true"] > div:has(> div > [data-fleet-selection-heading]) {
  padding: var(--fleet-card-padding);
  border: 1px solid var(--fleet-card-border);
  border-radius: var(--fleet-card-radius);
  background: var(--fleet-card-surface);
}

/* La surbrillance de dépôt des commandes suspendues garde son anneau. */
[data-react-fleet-view-panel="true"] div:has(> div > [data-fleet-view-toolbar="true"]):has(> [data-fleet-timeline-panel="true"]),
[data-react-fleet-view-panel="true"] [data-fleet-inspector-rail="true"] > [data-react-route-map-panel="true"],
[data-react-fleet-view-panel="true"] [data-fleet-inspector-rail="true"] > [data-fleet-suspended-panel="true"]:not(.ring-2),
[data-react-fleet-view-panel="true"] > div:has(> div > [data-fleet-selection-heading]) {
  box-shadow: var(--fleet-card-shadow);
}

[data-react-fleet-view-panel="true"] > div:has(> div > [data-fleet-selection-heading]) {
  margin: 0 var(--fleet-card-gap) var(--fleet-card-gap);
}

/* Les commandes suspendues reposent sur le fond pâle, comme les cartes sur la page,
   pour que chaque commande blanche reste bien visible. */
[data-react-fleet-view-panel="true"] [data-fleet-inspector-rail="true"] > [data-fleet-suspended-panel="true"] > div:last-child {
  padding: var(--fleet-card-padding);
  border-radius: 4px;
  background: var(--fleet-card-ground);
}

/* Commandes suspendues : total sur fond brun, prolongement de l'en-tête ;
   tonnage et contours dans des tons chauds. Le contenu reste inchangé. */
[data-react-fleet-view-panel="true"] [data-fleet-inspector-rail="true"] > [data-fleet-suspended-panel="true"] {
  --dispatch-suspended-alt-border: #d8d2c8;
  --dispatch-suspended-info-border: #d8d2c8;
  --dispatch-suspended-quantity-fill: #ece8e1;
  --suspended-transfer-border: #d8d2c8;
  --suspended-transfer-border-hover: #b9b0a3;
  --suspended-transfer-ink: #39312a;
}

[data-react-fleet-view-panel="true"] [data-fleet-inspector-rail="true"] [data-suspended-tonnage-summary="true"] {
  border-color: #5a4f46;
  background: #4a4039;
}

[data-react-fleet-view-panel="true"] [data-fleet-inspector-rail="true"] [data-suspended-tonnage-summary="true"] > span:first-child {
  color: #fff;
}

[data-react-fleet-view-panel="true"] [data-fleet-inspector-rail="true"] .suspended-card-interaction > div:first-child > button:first-child:not(:hover):not(:disabled) {
  border-color: #d8d2c8;
  color: #39312a;
}
